export const titleToKeyMap: { [key: string]: number | string } = {
    "Idwal Summary": "summary",
    "Design and Construction": 18,
    "Hull": 1,
    "Mooring Decks": 8,
    "Weather Decks and Fittings": 2,
    "Ballast Tanks and Systems": 9,
    "Accommodation": 3,
    "Bridge and Navigation Equipment": 10,
    "Engine Room and Machinery": 4,
    "Fire Fighting Equipment and Systems": 5,
    "Lifesaving Appliances": 12,
    "Safe Working Environment": 6,
    "Pollution Control": 13,
    "Onboard Management": 14,
    "Vessel Capabilities and Cargo Systems": 7,
    "Decarbonisation": 21,
};

export const textGenTitles = Object.keys(titleToKeyMap);